module.exports = __webpack_public_path__ + "img/access.beccc5d8.svg";